import React, {Component} from 'react';
import {folderEdit, folderGet, folderGetByDashboardByUser, folderGetByLevelByUser} from "../requests/Folder";
import FolderTree from "./FolderTree";
import {userChartCreate} from "../requests/UserChart";
import {CopyTwoTone} from '@ant-design/icons';
import {Alert, Col, Input, Modal, Row, Typography} from "antd";
import {connect} from "react-redux";
import {updateFolder} from "../../action/action";

const {Text} = Typography;

class NewDashboardModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            dashboardFolder: {},
            dashboardFolderID: '',
            isDashboardTitleRequired: false,
            title: '',
            modalVisible: false,
            isRefresh: true
        };
        this.handleFolderChange = this.handleFolderChange.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.editTitle = this.editTitle.bind(this);
        this.saveNewDashboard = this.saveNewDashboard.bind(this);
        this.onKeyPress = this.onKeyPress.bind(this);
    }

    handleFolderChange(value) {
        this.setState({dashboardFolderID: value._id});
    }

    editTitle(event) {
        this.setState({
            title: event.target.value
        });

    }

    async saveNewDashboard() {
        let {dashboardFolder, dashboardFolderID} = this.state;
        if (this.state.title === '') {
            this.setState({
                isDashboardTitleRequired: true
            });
        } else {
            let postData = {
                title: this.state.title,
                dashboard_id: this.props.item.dashboard_id,
                object: this.props.item.object,
                active: this.props.item.active,
                subscription_plan_id: this.props.item.subscription_plan_id,
                override_filters: this.props.item.override_filters,
                user_id: this.props.item.user_id,
                user_created: true
            };
            userChartCreate(postData, (response) => {
                folderGet(dashboardFolderID, (response2) => {
                    dashboardFolder = response2.data;
                    dashboardFolder.charts.push(response.data._id);
                    folderEdit(dashboardFolder, (response3) => {
                        this.setState({
                            dashboardFolder: response3.data,
                            dashboardFolderID: response3.data._id,
                            isRefresh: true
                        });
                        this.updateDashboard();
                    }, (error) => {
                        this.props.onError(true);
                        this.setState({modalVisible: false,});
                        document.removeEventListener("keydown", this.onKeyPress, false);
                        console.log(error);
                    });
                }, (error) => {
                    this.props.onError(true);
                    this.setState({modalVisible: false,});
                    document.removeEventListener("keydown", this.onKeyPress, false);
                    console.log(error);
                });
                this.setState({modalVisible: false,});
                document.removeEventListener("keydown", this.onKeyPress, false);
                this.props.onSuccess(true);
            }, (error) => {
                this.props.onError(true);
                this.setState({modalVisible: false,});
                document.removeEventListener("keydown", this.onKeyPress, false);
                console.log(error);
            });
        }
    }

    showModal = () => {
        this.setState({
            modalVisible: true,
            isRefresh: true
        });
        document.addEventListener("keydown", this.onKeyPress, false);
    };

    handleCancel = e => {
        this.setState({
            modalVisible: false,
            isRefresh: false
        });
        document.removeEventListener("keydown", this.onKeyPress, false);
    };

    async componentDidMount() {
        folderGetByDashboardByUser(this.props.userName, this.props.dashboardID, (response) => {
            this.setState({dashboardFolder: response.data, dashboardFolderID: response.data._id});
        });

    }

    onKeyPress(e) {
        if (e.keyCode === 13) {
            this.saveNewDashboard();
        }
        ;
    }

    updateRefresh = (val) => {
        this.setState({isRefresh: val});
    }

    updateDashboard = () => {
        folderGetByLevelByUser(this.props.userName, 0, (response) => {
            this.props.updateFolder(response.data);
        });
    }

    render() {
        return [
            <div onClick={this.showModal} key="sd_key"><CopyTwoTone/> Save as new dashboard
            </div>,
            <Modal key="key_saveModel"
                   title="Save as New Dashboard"
                   visible={this.state.modalVisible}
                   onOk={this.saveNewDashboard}
                   onCancel={this.handleCancel}
            >
                <Alert
                    message="Creates a clone of this dashboard in your navigation bar. Recommended when you have changed filter values and want to save the state as a new dashboard."
                    type="info"
                    showIcon
                />
                <div className="mt-4">
                    <Row>
                        <p>Enter Dashboard Name</p>
                        <Col span={24}>
                            <Input autoFocus name="new-title" id="new-title" onChange={this.editTitle}
                                   value={this.state.title}/>
                        </Col>
                    </Row>
                    <Row className="mt-4">
                        <p>Choose Destination Folder</p>
                        <Col span={24}>
                            <FolderTree selectedFolderID={this.state.dashboardFolderID} userName={this.props.userName}
                                        onChange={this.handleFolderChange} isRefresh={this.state.isRefresh}
                                        updateAction={this.updateRefresh}/>
                        </Col>

                    </Row>
                    <Row>
                        <Col span={24}>
                            <Text
                                type="danger">{this.state.isDashboardTitleRequired ? "*Title is required" : ""}</Text>
                        </Col>
                    </Row>
                </div>
            </Modal>
        ];
    }
}

export default (connect(null, {updateFolder})(NewDashboardModal));